/**
 * @typedef {import('./place-item.model').default} PlaceItemModel
 */

export default class PlaceSingleItemModel {
	/**
	 * @param {PlaceItemModel} placeItemModel 
	 * @param {number} amount - single amount
	 */
	constructor(placeItemModel, amount) {
		/**
		 * Single stake amount
		 * @type {number}
		 */
		this.am = amount;
		/**
		 * Single item place model
		 * @type {PlaceItemModel[]}
		 */
		this.i = [placeItemModel];
		/**
		 * Amount of combinations, always 1 since this is single
		 */
		this.comb = 1;
		/**
		 * Total odd for combination, always same as placeItemModel since
		 * we only have 1 item
		 */
		this.to = placeItemModel.oo;
	}
}